<div class="city-card" matRipple>
  <lib-base-card>
    <div class="teaser-image-wrapper">
      <img alt="city-image" [src]="image" />
    </div>

    <div class="card-content-container">
      <div class="explore-label">
        {{ 'city-card.text.explore-top-salons' | translate }}
      </div>
      <div class="city-name">{{ cityName }}</div>
    </div>
  </lib-base-card>
</div>
